// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Document: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="22" viewBox="0 0 16.5 22">
            <path
                fill="currentColor"
                d="M15.6964845,5.38398778 L11.1203126,0.807815909 C10.6003911,0.289699435 9.90429753,0 9.17382878,0 L2.75000066,0 C1.23105508,0 0,1.23105443 0,2.75 L0.000279307365,19.25 C0.000279307365,20.7689456 1.23133373,22 2.75027931,22 L13.75,22 C15.2689456,22 16.5,20.7689456 16.5,19.25 L16.5,7.32617188 C16.5,6.59570706 16.2121089,5.89961278 15.6964839,5.38398778 L15.6964845,5.38398778 Z M14.721094,6.3550818 C14.8714846,6.50117528 14.9703122,6.68164456 15.0347654,6.87500393 L10.3125,6.87500393 C9.93437487,6.87500393 9.625,6.56562841 9.625,6.18750393 L9.625,1.46437967 C9.81737131,1.53166783 9.9973672,1.62963653 10.145781,1.77800775 L14.721094,6.3550818 Z M15.125,19.2500039 C15.125,20.0079733 14.5079694,20.6250039 13.75,20.6250039 L2.75,20.6250039 C1.99203128,20.6250039 1.375,20.0079733 1.375,19.2500039 L1.375,2.75000393 C1.375,1.99203455 1.99203128,1.37500393 2.75,1.37500393 L8.25,1.37500393 L8.25,6.18750393 C8.25,7.32617581 9.17382812,8.25000393 10.3125,8.25000393 L15.125,8.25000393 L15.125,19.2500039 Z"
            />
        </svg>
    );
};

export default React.memo(Document);
